import React, { Fragment } from 'react';
import personalaccess from '../../../../../images/personal.png';
import personalaccess1 from '../../../../../images/personal1.jpg';
import '../../driverFaq.css';

const PersonalVehicleAccess = () => (
  <Fragment>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={personalaccess} className="personal-image" />
    </div>
    <p>
      You may enter the parking lot via Bloor St. W or St. George St.
      entrances. (Note: you must exit the parking lot via St. George St.
      only)
    </p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={personalaccess1} className="personal-image" />
    </div>
    <p>
      Enter the parking lot ramp and the parking gate will open
      automatically. Drive down to P3 and you will find the Autzu vehicles.{' '}
    </p>
    <br />
  </Fragment>
);

export default PersonalVehicleAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Bloor/PersonalVehicleAccess.js